import { render, staticRenderFns } from "./relationship-detail.vue?vue&type=template&id=2f16cb50&scoped=true"
import script from "./relationship-detail.vue?vue&type=script&lang=js"
export * from "./relationship-detail.vue?vue&type=script&lang=js"
import style0 from "./relationship-detail.vue?vue&type=style&index=0&id=2f16cb50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f16cb50",
  null
  
)

export default component.exports